export default __webpack_public_path__ + "static/media/warning--uneven-roads-ahead--g1.4444a9a8.png";